import React from 'react';
import Bulk_Leave_Cert from './Bulk_Leave_Cert';
import '../../../CommonCSS/SocietyCSS.css'


const BulkLeaveCertApp = () => {
  return (
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{ borderRadius: '8px' }}>
          <div className="card-header-css" style={{ borderRadius: '8px', textAlign: 'center' }} >
            <h5> Bulk Leaving Certificate </h5>
          </div>
        </div>
        <Bulk_Leave_Cert/>
      </div>
    </div >
  );
};

export default BulkLeaveCertApp;
